module.exports = __webpack_public_path__ + "media/images/countrysquared/km-fb9eb24dcc7460ea35d8864cb4f8f32c.svg";